import React, { memo } from 'react';
import { cn } from 'lib/utils';

interface Props {
  size?: 'small' | 'default' | 'large';
  color?: 'default' | 'primary' | 'secondary' | 'muted';
  className?: string;
}

function Loader({ size = 'default', color = 'primary', className }: Props) {
  const sizeConfig = {
    small: { px: 24, stroke: 2 },
    default: { px: 48, stroke: 3 },
    large: { px: 64, stroke: 4 },
  };

  const colorConfig = {
    default: 'text-foreground',
    primary: 'text-primary',
    secondary: 'text-secondary-foreground',
    muted: 'text-muted-foreground',
  };

  const { px, stroke } = sizeConfig[size];
  const colorClass = colorConfig[color];

  return (
    <svg
      className={cn('animate-spin', colorClass, className)}
      width={px}
      height={px}
      viewBox={`0 0 ${px} ${px}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Loading"
      role="status"
    >
      <circle
        className="opacity-25"
        cx={px / 2}
        cy={px / 2}
        r={(px - stroke) / 2}
        stroke="currentColor"
        strokeWidth={stroke}
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d={`M${px / 2} ${stroke / 2}a${(px - stroke) / 2} ${
          (px - stroke) / 2
        } 0 0 1 0 ${px - stroke}`}
      />
    </svg>
  );
}

export default memo(Loader);
